import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import {
  getTopAndVisibleDomains,
  getViewForChart,
  getViewGroupForChart,
  getVisibleEntriesForView,
} from '../../redux/sonar/sonarSelectors';
import { FOOTPRINT_ALL_VIEWS, SONAR_SECTIONS, VIEWS } from '../../constants';
import { SONAR_DATA_KEYS, getSortingByStat } from '../../utils/chart';
import { Panel } from '../../components/layout/layout';
import WithToolbarWrapper from '../with-toolbar-wrapper/WithToolbarWrapper';
import ExtendedViewToolbar from '../extended-view-toolbar/ExtendedViewToolbar';
import ScatterChart from '../../components/charts/d3/scatter/ScatterChart';

const CHART_INDEX = 1;

function PresenceAll() {
  const { t } = useTranslation('sonar');

  const view = useSelector(getViewForChart(SONAR_SECTIONS.FOOTPRINT, CHART_INDEX));
  const group = useSelector(getViewGroupForChart(SONAR_SECTIONS.FOOTPRINT, CHART_INDEX));

  const domainEntries = useSelector(getEntriesSelector(view, group));

  const viewOptions = [
    {
      label: t('topByReach', { size: 10 }),
      value: FOOTPRINT_ALL_VIEWS.TOP_10_PRESENCE,
    },
    {
      label: t('topByVitality', { size: 10 }),
      value: FOOTPRINT_ALL_VIEWS.TOP_10_ENERGY,
    },
    {
      label: t('topByReach', { size: 20 }),
      value: FOOTPRINT_ALL_VIEWS.TOP_20_PRESENCE,
    },
    {
      label: t('topByVitality', { size: 20 }),
      value: FOOTPRINT_ALL_VIEWS.TOP_20_ENERGY,
    },
    { label: t('focus'), value: VIEWS.FOCUS },
    { label: t('all'), value: VIEWS.ALL },
    { label: t('groups'), value: VIEWS.GROUPS },
  ];

  return (
    <Panel>
      <WithToolbarWrapper>
        <ExtendedViewToolbar
          chartIndex={CHART_INDEX}
          section={SONAR_SECTIONS.FOOTPRINT}
          viewOptions={viewOptions}
          allowGroupsFilter
          disableChartTypes>
          {() => (
            <ScatterChart
              data={domainEntries}
              dataKeys={[SONAR_DATA_KEYS.PRESENCE, SONAR_DATA_KEYS.ENERGY]}
              xLabel={t('reach')}
              yLabel={t('vitality')}
            />
          )}
        </ExtendedViewToolbar>
      </WithToolbarWrapper>
    </Panel>
  );
}

const ADDITIONAL_VIEW_SELECTORS = {
  [FOOTPRINT_ALL_VIEWS.TOP_10_PRESENCE]: getTopAndVisibleDomains(10, getSortingByStat(SONAR_DATA_KEYS.PRESENCE)),
  [FOOTPRINT_ALL_VIEWS.TOP_10_ENERGY]: getTopAndVisibleDomains(10, getSortingByStat(SONAR_DATA_KEYS.ENERGY)),
  [FOOTPRINT_ALL_VIEWS.TOP_20_PRESENCE]: getTopAndVisibleDomains(20, getSortingByStat(SONAR_DATA_KEYS.PRESENCE)),
  [FOOTPRINT_ALL_VIEWS.TOP_20_ENERGY]: getTopAndVisibleDomains(20, getSortingByStat(SONAR_DATA_KEYS.ENERGY)),
};

function getEntriesSelector(view, group) {
  return ADDITIONAL_VIEW_SELECTORS[view] || getVisibleEntriesForView(view, group);
}

export default PresenceAll;
